import styled from "styled-components";
import { COLOUR_CONSTANT } from "../../../../utils/contants";

export const TotalHeaderStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  .heading {
    display: flex;
    /* align-items: center; */
    gap: 5px;
  }
  button {
    height: 36px;
  }
`;
